/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'attention': {
    width: 24,
    height: 23,
    viewBox: '0 0 24 23',
    data: '<g fill-rule="evenodd"><path pid="0" d="M2.393 17.37l8.04-14.1c.3-.54.87-.87 1.5-.87s1.17.33 1.5.87l8.04 14.1c.3.54.3 1.17 0 1.71s-.87.84-1.47.84H3.863c-.63 0-1.17-.33-1.47-.84-.3-.54-.33-1.17 0-1.71m1.47 4.65h16.05c1.38 0 2.61-.72 3.3-1.89.69-1.2.69-2.61.03-3.81l-8.04-14.1A3.782 3.782 0 0011.873.3c-1.41 0-2.64.72-3.33 1.92l-8.04 14.1c-.69 1.2-.66 2.61.03 3.81.72 1.2 1.95 1.89 3.33 1.89"/><path pid="1" d="M11.753 14.61c.57 0 1.05-.48 1.05-1.05v-5.7c0-.57-.48-1.05-1.05-1.05-.57 0-1.05.48-1.05 1.05v5.7c0 .57.48 1.05 1.05 1.05m0 3.9c.57 0 1.05-.48 1.05-1.05v-.9c0-.57-.48-1.05-1.05-1.05-.57 0-1.05.48-1.05 1.05v.9c0 .57.48 1.05 1.05 1.05"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/dist/icons/attention.js